import PropTypes from 'prop-types';
import React from 'react';
import 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/MotoInsight/MotoInsightCTA.scss';

const MotoInsightCTA = ({ buttonClass, ctaLabel, serialNo }) => {
    if (!serialNo) return null;
    return (
        <button
            className={`motocommerce-vehicle-link ${buttonClass} motoInsight-cta`}
            data-stock-id={serialNo}
            gtmsm360="moto-insight-link"
        >
            <span className="motoInsight-label">{ctaLabel}</span>
        </button>
    );
};

MotoInsightCTA.defaultProps = {
    buttonClass: 'sr-button-1',
    ctaLabel: null,
    serialNo: '',
};

MotoInsightCTA.propTypes = {
    buttonClass: PropTypes.string,
    ctaLabel: PropTypes.string,
    serialNo: PropTypes.string,
};

MotoInsightCTA.displayName = 'MotoInsightCTA';

export default MotoInsightCTA;
